<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" *ngIf="name == null" id="myModalLabel">
    Add Client Company
  </h4>
  <h4 class="modal-title" *ngIf="name != null" id="myModalLabel">
    Invite a New Client User
  </h4>
</div>

<!-- <form [formGroup]="inviteTypeSelection">
    <div>
        <input id="new" type="radio" value="new" name="type" formControlName="type">
        <label for="new">New Client</label>
    </div>

    <div>
        <input id="existing" type="radio" value="existing" name="type" formControlName="type">
        <label for="existing">Existing Clients</label>
    </div>
</form> -->

<div class="modal-body" [hidden]="inviteType == 'existing'">
  <p *ngIf="name == null">
    Simply provide a client company name to add it to your client list now.
    Later, you can add client users and provide them access to their client
    workspace when you are ready.
  </p>
  <p *ngIf="name != null">
    Enter the name and email address of the client user you wish to invite.
    Client Hub will email them an invite. When this invite is accepted, he/she
    will be added to this workspace
  </p>
  <form [formGroup]="inviteForm">
    <div class="form-group" *ngIf="name == null || name == undefined">
      <label for="inputCompanyName">Client Company Name</label>
      <input
        id="inputCompanyName"
        autofocus
        type="text"
        formControlName="company_name"
        [ngClass]="
          formUtil.displayFieldCss(
            inviteForm,
            'company_name',
            inviteFormSubmitAttempt
          )
        "
        class="form-control"
        placeholder="Will's Windsurf Shop"
      />
    </div>
    <div class="row" *ngIf="name != null">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="inputCompanyOwner" *ngIf="name == null"
            >Main Contact Name</label
          >
          <label for="inputCompanyOwner" *ngIf="name != null">User Name</label>
          <input
            data-step="4"
            data-intro="Type the user name"
            id="inputCompanyOwner"
            type="text"
            class="form-control"
            formControlName="name"
            placeholder="William Shakespeare"
            [ngClass]="
              formUtil.displayFieldCss(
                inviteForm,
                'name',
                inviteFormSubmitAttempt
              )
            "
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !inviteForm.get('name').valid &&
              inviteForm.get('name').dirty &&
              inviteFormSubmitAttempt
            "
          >
            Name cannot be empty
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="inputCompanyEmail" *ngIf="name != null">User Email</label>
          <label for="inputCompanyEmail" *ngIf="name == null"
            >Main Contact Email</label
          >
          <input
            id="inputCompanyEmail"
            data-step="5"
            data-intro="Type the user email. For this Sample Client company, you could use your own personal email address (different than the one you used to sign up for Client Hub)."
            type="text"
            class="form-control"
            formControlName="email"
            [ngClass]="
              formUtil.displayFieldCss(
                inviteForm,
                'email',
                inviteFormSubmitAttempt
              )
            "
            placeholder="william@willswindsurf.com"
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !inviteForm.get('email').valid &&
              inviteForm.get('email').dirty &&
              inviteFormSubmitAttempt
            "
          >
            Email must be valid
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- <div class="modal-body" [hidden]="inviteType == 'new'">
  <p>Please select the members you wanna add to this company</p>
  <p *ngFor="let u of availableUsers">
    {{ u.user.full_name }}
  </p>
</div> -->

<div class="modal-footer">
  <div class="row">
    <div class="col-4 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-8">
      <button
        data-step="6"
        data-intro='<strong>IMPORTANT:</strong> After clicking this button, open this email account in a different browser (Firefox instead of Chrome etc.) or in a "New Incognito Window" so that you can accept the invite as this client user without closing this session as the accountant user.'
        type="button"
        [disabled]="!inviteForm.valid && inviteFormSubmitAttempt"
        class="btn btn-primary"
        (click)="inviteClient()"
      >
        <span *ngIf="name != null">Invite Client User</span>
        <span *ngIf="name == null">Add Client Company</span>
      </button>
    </div>
  </div>
</div>
